import axios from "axios"
import React, { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { toast } from "react-toastify"
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Card,
  CardBody,
  Button,
} from "reactstrap"

// Utility to detect if a field is a date field
const isDateField = fieldName => {
  const keywords = ["date", "dob", "birth", "admit", "pdate", "mbdate"]
  return keywords.some(keyword => fieldName.toLowerCase().includes(keyword))
}

const CustomEdit = () => {
  const token = JSON.parse(localStorage.getItem("Token"))

  const location = useLocation()
  const navigate = useNavigate()
  const data = location?.state?.data || []

  const [formData, setFormData] = useState([])
  const [originalData, setOriginalData] = useState([])
  const [alertMsg, setAlertMsg] = useState("")

  const excludedTitles = [
    "Student's Photo",
    "Mother's Photo",
    "Father's Photo",
    "Guardian's Photo",
    "Upload documents",
    "Upload documents details",
  ]

  useEffect(() => {
    if (Array.isArray(data)) {
      setFormData(data)
      setOriginalData(JSON.parse(JSON.stringify(data))) // deep copy
    }
  }, [data])

  const handleChange = (table_name, field_name, newValue) => {
    setFormData(prevData =>
      prevData.map(item => {
        if (item.table_name === table_name && item.field_name === field_name) {
          return { ...item, value: newValue }
        }
        return item
      })
    )
  }

  const getChangedFields = () => {
    return formData
      .filter(item => {
        const originalItem = originalData.find(
          o =>
            o.table_name === item.table_name && o.field_name === item.field_name
        )

        const isExcludedField =
          item.field_name === "cat_details" || item.field_name === "uploadeddoc"

        return (
          !isExcludedField && originalItem && originalItem.value !== item.value
        )
      })
      .map(item => ({
        table_name: item.table_name,
        field_name_in_table: item.field_name_in_table,
        value: item.value,
      }))
  }

  const handleSubmit = async () => {
    const changedFields = getChangedFields()

    if (changedFields.length === 0) {
      setAlertMsg("No changes made.")
      setTimeout(() => setAlertMsg(""), 2000)
      return
    }

    // axios.post('/api/StudentProfilePic/update-editable-field')
    // await axios({
    //     method : 'POST',
    //     url : '/api/StudentProfilePic/update-editable-field',
    //     data : { changedFields},
    //     headers: {
    //         localStorage.getItem("Token")
    //     }
    // })
    await axios({
      method: "POST",
      url: "https://marcopolo.prisms.in/api/StudentProfilePic/update-editable-field",
      data: { data: changedFields },
      headers: {
        Authorization: token,
      },
    }).then(res => {
      toast.success("Updated Successfully ✅")
      navigate("/student-profile")
    //   setSubmitted(true)
    })
  }

  const editableFields = formData.filter(
    item =>
      !excludedTitles.includes(item.field_title) &&
      item.field_name !== "cat_details" &&
      item.field_name !== "uploadeddoc" &&
      item.editable_by_parents === 1
  )

  return (
    <div className="page-content">
      <Container className="p-0">
        <Card className="p-0 shadow-sm rounded-3">
          <CardBody className="p-3">
            <h1 className="text-center mb-4 fs-3" style={{ color: "#3c3c3c" }}>
              Update Details
            </h1>

            {alertMsg && <Alert color="warning">{alertMsg}</Alert>}

            <Form>
              {editableFields.map(item => (
                <FormGroup key={item.field_id} className="mb-3">
                  <Row>
                    <Col md={4}>
                      <Label for={`field-${item.field_id}`}>
                        {item.field_title}
                      </Label>
                    </Col>
                    <Col md={8}>
                      {item.field_title === "Blood group" ? (
                        <div className="d-flex flex-row p-0 w-100">
                          <Input
                            type="select"
                            name="blood_group"
                            id={`field-${item.field_id}`}
                            value={item.value?.trim() || ""}
                            disabled={item.editable_by_parents !== 1}
                            onChange={e =>
                              handleChange(
                                item.table_name,
                                item.field_name,
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select Blood Group</option>
                            <option value="A+">A+</option>
                            <option value="A-">A−</option>
                            <option value="B+">B+</option>
                            <option value="B-">B−</option>
                            <option value="AB+">AB+</option>
                            <option value="AB-">AB−</option>
                            <option value="O+">O+</option>
                            <option value="O-">O−</option>
                          </Input>
                        </div>
                      ) : (
                        <Input
                          id={`field-${item.field_id}`}
                          type={isDateField(item.field_name) ? "date" : "text"}
                          value={
                            isDateField(item.field_name)
                              ? item.value?.substring(0, 10) || ""
                              : item.value || ""
                          }
                          disabled={item.editable_by_parents !== 1}
                          onChange={e =>
                            handleChange(
                              item.table_name,
                              item.field_name,
                              e.target.value
                            )
                          }
                        />
                      )}
                    </Col>
                  </Row>
                </FormGroup>
              ))}

              <Row className="mt-4">
                <Col className="d-flex justify-content-center">
                  <Button color="primary" onClick={handleSubmit}>
                    Update
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default CustomEdit
